export default "__VITE_ASSET__BE_U_R7l__"